document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('[data-ct-hero-product]');
  if (!section) return;

  const form = section.querySelector('#ct-hp-form');
  const variantInput = section.querySelector('[data-ct-variant-input]');
  const qtyInput = section.querySelector('[data-ct-qty-input]');
  const qtyValueEl = section.querySelector('[data-ct-qty-value]');
  const qtyMinusBtn = section.querySelector('[data-ct-qty-minus]');
  const qtyPlusBtn = section.querySelector('[data-ct-qty-plus]');
  const bundleButtons = section.querySelectorAll('[data-ct-bundle]');
  const atcButton = section.querySelector('.ct-hp__atc');

  let quantity = 1;

  function selectedBundle(buttons) {
    var featured = null;
    var firstWithId = null;
    buttons.forEach(function (btn) {
      if (!btn.dataset.variantId) return;
      if (!firstWithId) firstWithId = btn;
      if (btn.classList.contains('is-selected')) featured = btn;
    });
    return featured || firstWithId;
  }

  function syncVariant(btn) {
    if (variantInput && btn && btn.dataset.variantId) {
      variantInput.value = btn.dataset.variantId;
    }
  }

  function selectBundle(btn) {
    bundleButtons.forEach(function (b) {
      b.classList.remove('is-selected');
    });
    if (!btn) return;
    btn.classList.add('is-selected');
    syncVariant(btn);
  }

  selectBundle(selectedBundle(bundleButtons));

  bundleButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectBundle(btn);
    });
  });

  // --- Quantity controls ---
  function updateQtyDisplay() {
    if (qtyValueEl) qtyValueEl.textContent = quantity;
    if (qtyInput) qtyInput.value = quantity;
  }

  if (qtyMinusBtn) {
    qtyMinusBtn.addEventListener('click', function () {
      if (quantity > 1) {
        quantity -= 1;
        updateQtyDisplay();
      }
    });
  }

  if (qtyPlusBtn) {
    qtyPlusBtn.addEventListener('click', function () {
      quantity += 1;
      updateQtyDisplay();
    });
  }

  // --- Add to cart (AJAX) ---
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!variantInput || !variantInput.value) {
        console.error('No variant selected');
        return;
      }

      const formData = new FormData(form);

      if (atcButton) {
        atcButton.disabled = true;
        atcButton.dataset.originalText = atcButton.textContent;
        atcButton.textContent = 'Adding...';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Add to cart failed');
            });
          }
          return response.json();
        })
        .then(function () {
          if (atcButton) {
            atcButton.textContent = 'Added ✓';
            setTimeout(function () {
              atcButton.textContent = atcButton.dataset.originalText;
              atcButton.disabled = false;
            }, 1500);
          }
          // Trigger a cart update event so your cart drawer/icon can refresh
          document.dispatchEvent(new CustomEvent('ct:cart:updated'));
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          if (atcButton) {
            atcButton.textContent = 'Error — try again';
            atcButton.disabled = false;
          }
        });
    });
  }

  updateQtyDisplay();
});
